var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isDone && _vm.hasDropdown
        ? _c(
            "div",
            [
              _c("CompassSplitButton", {
                ref: "activityUpdateStatusButton",
                class: ["status__button", _vm.statusButtonClass],
                attrs: {
                  "data-bot": "activity-update-status-button",
                  label: _vm.label,
                  type: _vm.statusButtonType,
                  disabled: _vm.disabled,
                  loading: _vm.pending
                },
                on: {
                  clickOnLabel: function($event) {
                    return _vm.$emit("updateStatus")
                  },
                  clickOnArrow: function($event) {
                    _vm.showDropdown = !_vm.showDropdown
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "CompassDropdown",
                {
                  attrs: {
                    parentRef: "activityUpdateStatusButton",
                    dropdownClass: "activity-update-status-button__dropdown",
                    placement: "top-end",
                    isVisible: _vm.showDropdown
                  },
                  on: {
                    onVisibilityChanged: function(visibility) {
                      return _vm.handleDropdownVisibility(visibility)
                    }
                  }
                },
                [
                  _c("CompassDropdownOption", {
                    attrs: {
                      label: _vm.$t.__(
                        "activities.detailPanel.ActivityUpdateStatusButton.close_and_create_new_task"
                      ),
                      icon: "task",
                      isCheckable: false
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("updateStatus", true)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("CompassButton", {
            class: ["status__button", _vm.statusButtonClass],
            attrs: {
              "data-bot": "activity-update-status-button",
              label: _vm.label,
              leftIcon: "check",
              type: _vm.statusButtonType,
              disabled: _vm.disabled,
              loading: _vm.pending
            },
            on: {
              click: function($event) {
                return _vm.$emit("updateStatus")
              }
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }